import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpReverseBid
     * @memberof app
     *
     * @restrict E
     * @scope
     *
     * @description
     * This is the form for submitting bids on reverse auctions.
     *
     * @author flzemke.btc
     */
    angular.module('app').directive('pkpReverseBid', pkpReverseBid);

    function pkpReverseBid(
        $window,
        auctionResource,
        auctionsOverviewService,
        INCLUDE
    ) {
        return {
            restrict: 'E',
            scope: {
                auction: '=',
                config: '='
            },
            template: require('app/_directives/pkp-reverse-bid.directive.html'),
            link: linkFn
        };

        function linkFn(scope) {
            scope.INCLUDE = INCLUDE;
            scope.MINIMUM_BID_INFO_BLAH =
                auctionsOverviewService.MINIMUM_BID_INFO_BLAH;
            scope.uiCheckPage = false;
            scope.uiSubmitAuctionSuccess = false;
            scope.uiSubmitAuctionError = false;
            scope.uiSubmitAuctionErrorMsg = '=';
            scope.uiSubmitting = false;
            scope.uiShowOverviewButton = false;
            scope.bid = {};
            scope.submitReverseBid = submitReverseBid;
            scope.goBack = goBack;

            scope.possibleUnits = scope.auction.possibleUnits;
            if (angular.isUndefined(scope.possibleUnits[0].periodType)) {
                scope.possibleUnits[0].label =
                    scope.possibleUnits[0].label + '/Runtime';
                scope.possibleUnits[0].unspecificPeriod = true;
            }

            function submitReverseBid(isValid) {
                if (!isValid) {
                    return false;
                }

                if (!scope.uiCheckPage) {
                    scope.uiCheckPage = true;
                    return false;
                }

                scope.uiSubmitting = true;

                auctionResource.reverseAuctionBid(
                    { auctionId: scope.auction.id },
                    scope.bid,
                    function () {
                        scope.uiSubmitAuctionSuccess = true;
                        scope.uiSubmitAuctionError = false;
                        scope.uiShowOverviewButton = true;
                    },
                    function (res) {
                        scope.uiSubmitting = false;
                        scope.uiSubmitAuctionError = true;
                        scope.uiSubmitAuctionErrorMsg = res.data.message;
                    }
                );

                return true;
            }

            function goBack() {
                $window.history.back();
            }
        }
    }
})();
